<script>
export default {
	created() {
		// Obtém a tradução
		const translatedText = this.$t('footer.privacyCookies.label');
		// Define o novo título da página
		document.title = translatedText + " | " + document.title.substring(document.title.indexOf("|") + 1);
	},
	data() {
		return {
			privacyCookies: ''
		}
	},
	async mounted() {
		this.privacyCookies = await ((await fetch(`mocks${import.meta.env.VITE_BASE_PATH}privacyCookies.html`)));
		this.privacyCookies = await this.privacyCookies.text()

	},
	beforeRouteEnter(to, from, next) {
		window.scrollTo(0, 0);
		next();
	}
}
</script>

<template>
	<section class="wrapper__terms" v-html="this.privacyCookies">

	</section>
</template>
